import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { PricingSelector } from './PricingSelector';
export function FinalCTA() {
  const initialTime = 23 * 3600 + 43 * 60 + 36;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-10 md:py-20 bg-rugby-green-900 relative pattern-lines" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <div className="max-w-5xl mx-auto" data-id="element-189">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-6 md:mb-8" data-id="element-190">
            <h2 className="text-2xl md:text-5xl font-display text-white mb-1.5 md:mb-3" data-id="element-191">
              No dejes pasar esta oportunidad
            </h2>
            <p className="text-xs md:text-base text-slate-300 mb-3 md:mb-5" data-id="element-192">
              Termina en
            </p>

            <div className="flex gap-1.5 md:gap-2.5 justify-center" data-id="element-193">
              <div className="bg-rugby-green-950 border border-red-900/50 text-white font-display text-xl md:text-3xl w-11 h-12 md:w-14 md:h-16 flex items-center justify-center rounded-lg shadow-lg" data-id="element-194">
                {formatTime(hours)}
              </div>
              <div className="text-xl md:text-3xl font-display text-red-500 mt-1 md:mt-1.5" data-id="element-195">
                :
              </div>
              <div className="bg-rugby-green-950 border border-red-900/50 text-white font-display text-xl md:text-3xl w-11 h-12 md:w-14 md:h-16 flex items-center justify-center rounded-lg shadow-lg" data-id="element-196">
                {formatTime(minutes)}
              </div>
              <div className="text-xl md:text-3xl font-display text-red-500 mt-1 md:mt-1.5" data-id="element-197">
                :
              </div>
              <div className="bg-rugby-green-950 border border-red-900/50 text-white font-display text-xl md:text-3xl w-11 h-12 md:w-14 md:h-16 flex items-center justify-center rounded-lg shadow-lg" data-id="element-198">
                {formatTime(seconds)}
              </div>
            </div>
          </motion.div>

          <PricingSelector data-id="element-199" />
        </div>
      </div>
    </section>;
}